import React, { useEffect, useState } from "react";
import * as styles from "./Accordion.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import SlideDownUp from "@app/components/SlideDownUp";

const Accordion = ({
	headline,
	subHeadline,
	actions,
	initialOpen = false,
	showInstant = false,
	children,
	className,
	icon,
}) => {
	const [show, setShow] = useState(initialOpen);
	const accordionClassName = classNames(
		{
			[styles["accordion"]]: true,
			[styles["open"]]: show,
			[className]: !!className,
			open: show,
		},
		"accordion",
	);

	return (
		<div className={accordionClassName}>
			<div
				className={classNames("header", styles["header"])}
				onClick={(event) => {
					event.stopPropagation();
					setShow(!show);
				}}
			>
				<div className={styles["header-wrapper"]}>
					{icon && <img src={icon} alt={headline} className={styles["headline-icon"]} />}
					<div className={styles["headline"]}>{headline}</div>
					{actions && (
						<div className={styles["actions"]}>
							{actions
								.filter((action) => !!action)
								.map((action, index) => (
									<div key={index}>{action}</div>
								))}
						</div>
					)}
				</div>
				{subHeadline && <div className={styles["sub-headline"]}>{subHeadline}</div>}
			</div>
			{showInstant ? (
				<div>
					<div>
						<div className={classNames("body", styles["body"])}>{children}</div>
					</div>
				</div>
			) : (
				<SlideDownUp show={show}>
					<div>
						<div className={classNames("body", styles["body"])}>{children}</div>
					</div>
				</SlideDownUp>
			)}
		</div>
	);
};

Accordion.propTypes = {
	headline: PropTypes.any,
	subHeadline: PropTypes.any,
	actions: PropTypes.array,
	children: PropTypes.node,
	initialOpen: PropTypes.bool,
	showInstant: PropTypes.bool,
	className: PropTypes.string,
};

export default Accordion;
